import React from 'react'
// import PropTypes from 'prop-types'
import PrivateRoute from '../../components/PrivateRoute'
import EntitiesHome from '../../pageComponents/entidades/Home'

const EntidadesPage = props => {
  return (
    <PrivateRoute component={EntitiesHome} {...props} />
  )
}

EntidadesPage.propTypes = {}

export default EntidadesPage